import React from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@radix-ui/react-icons';

import type { OrderBy } from './use-order-by';

import styles from './sortable-header-cell.module.scss';
type SortableHeaderCellProps = React.ThHTMLAttributes<HTMLTableCellElement> & {
  sortKey: string;
  orderBy: OrderBy;
  onOrder: (key: string) => void;
};

export const SortableHeaderCell: React.FC<SortableHeaderCellProps> = ({
  sortKey,
  orderBy,
  onOrder,
  children,
  ...props
}) => (
  <HeaderCell onClick={() => onOrder(sortKey)} {...props}>
    {children}
    {orderBy?.key === sortKey &&
      (orderBy.direction === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />)}
  </HeaderCell>
);

export const HeaderCell = ({ className, ...props }: React.ComponentPropsWithoutRef<'th'>) => (
  <th
    className={className ? `${styles['header-cell']} ${className}` : styles['header-cell']}
    {...props}
  />
);
